const url = window.location.pathname.split('/')[1];
url === 'entreprises'
  ? (document.getElementById('prospect_come_from').value = 'entreprise')
  : '';
